// src/pages/Search/SearchResults.js
import React from 'react';
import { SearchIcon } from '../../components/common/Icons';
import SalonCard from '../../components/ui/SalonCard';

const SearchResults = ({ searchTerm, onSearchChange, filteredSalons, navigateTo }) => {
  // Handler for opening search screen
  const handleSearchClick = () => {
    navigateTo('searchScreen', { mode: 'screen' });
  };
  
  return (
    <div className="flex-1 overflow-y-auto pb-16">
      <header className="p-4 bg-white sticky top-0 z-10">
        <div 
          className="flex bg-gray-100 rounded-md p-2 items-center"
          onClick={handleSearchClick}
        >
          <SearchIcon size={20} className="text-gray-500 ml-2 mr-2" />
          <input
            className="bg-transparent flex-1 outline-none"
            placeholder="Toate serviciile în jurul locației tale"
            type="text"
            value={searchTerm}
            onChange={onSearchChange}
            readOnly
          />
          <button className="bg-gray-200 rounded-md p-1 ml-2">
            <SearchIcon size={16} />
          </button>
        </div>
      </header>

      <section className="p-4">
        <div className="space-y-6">
          {filteredSalons.length > 0 ? (
            filteredSalons.map(salon => (
              <SalonCard 
                key={salon.id}
                salon={salon}
                onClick={() => navigateTo('salon', { salon })}
              />
            ))
          ) : (
            <div className="text-center py-8">
              <p className="text-gray-500">Nu am găsit rezultate pentru "{searchTerm}"</p>
              <p className="text-gray-500 mt-2">Încearcă alte cuvinte cheie sau categorii.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default SearchResults;